export const postCharacteristics = {
  "ser-mulher-dia-internacional": {
    title: "Qualidades Únicas",
    dotColor: "bg-pink-500",
    items: [
      {
        title: "A capacidade de amar incondicionalmente",
        poem:
          "Vi amor que não pede troca,\nque permanece quando o mundo some —\ne aprendi que amar assim\né dom que ela carrega no peito.",
      },
      {
        title: "A força para enfrentar qualquer desafio",
        poem:
          "Ela cai, levanta, segue em frente,\nsem alarde, sem pedir licença —\ne eu reconheço nela\numa coragem que me ensina.",
      },
      {
        title: "A sabedoria de saber quando recuar e quando avançar",
        poem:
          "Há hora de lutar, hora de esperar;\nela sabe o ritmo do próprio caminho —\ne nisso vejo uma sabedoria\nque poucos homens aprendem cedo.",
      },
      {
        title: "A delicadeza de tocar vidas sem perceber",
        poem:
          "Um gesto leve, uma palavra ao tempo certo —\ne a vida de alguém muda sem barulho.\nEla toca sem saber que tocou.",
      },
      {
        title: "A coragem de ser autêntica em um mundo que pede conformidade",
        poem:
          "Prefere ser inteira a ser aceita pela metade.\nE eu, homem que observa de fora,\nadmiro antes de entender.",
      },
    ],
  },
  "solidao-essencial": {
    title: "Benefícios da Solidão",
    dotColor: "bg-blue-500",
    items: [
      {
        title: "A solidão nos permite conhecer nossa verdadeira essência",
        poem:
          "No silêncio, sem máscara e sem plateia,\ndescobri quem sou quando ninguém olha —\ne foi na solidão que me encontrei.",
      },
      {
        title: "É no silêncio que encontramos clareza e sabedoria",
        poem:
          "O barulho do mundo confunde;\no silêncio responde sem pressa.\nAprendi a ouvir o que importa.",
      },
      {
        title: "Aceitar a solidão nos torna mais independentes",
        poem:
          "Não preciso de aplauso para existir,\nnem de companhia para respirar —\nminha paz deixou de ser emprestada.",
      },
      {
        title: "A solidão nos ensina a valorizar verdadeiramente os outros",
        poem:
          "Quem sabe estar só\naprende a não desperdiçar presença.\nCada encontro passou a pesar mais.",
      },
      {
        title: "É na solidão que nossa criatividade floresce",
        poem:
          "Ideias brotam onde o ruído não alcança;\nno quarto fechado, escrevo, penso, crio —\ne a solidão virou meu ateliê.",
      },
    ],
  },
  "talvez-amanha": {
    title: "Os Talvez da Vida",
    dotColor: "bg-orange-500",
    items: [
      {
        title: "Os talvez nos mantêm em movimento",
        poem:
          "Não paro na certeza que mata o sonho;\no talvez me puxa para a manhã seguinte —\ne eu sigo, esperançoso, em frente.",
      },
      {
        title: "Cada talvez é uma possibilidade de felicidade",
        poem:
          "Entre o sim e o não, há um jardim\nonde a felicidade ainda pode nascer.\nEu planto esperança nesse terreno.",
      },
      {
        title: "O amor é feito de pequenos talvez cotidianos",
        poem:
          "Talvez ela ligue, talvez eu escreva,\ntalvez o café esfrie na xícara —\ne o amor mora nesses quase nada.",
      },
      {
        title: "Talvez seja melhor não ter certezas absolutas",
        poem:
          "A vida inteira não cabe numa resposta;\ndeixei de exigir garantias —\ne passei a confiar no caminho.",
      },
      {
        title: "Os talvez nos permitem sonhar e esperar",
        poem:
          "Sonhar não é ingenuidade:\né recusar que o amanhã já esteja escrito.\nEu sonho porque ainda há talvez.",
      },
    ],
  },
  "deixar-partir": {
    title: "Lições do Amor",
    dotColor: "bg-orange-500",
    items: [
      {
        title: "O amor verdadeiro coloca o outro em primeiro lugar",
        poem:
          "Se o seu bem pede minha ausência,\neu obedeço, mesmo com o peito ferido —\nporque amar é querer o melhor para ela.",
      },
      {
        title: "Deixar partir pode ser um ato de amor",
        poem:
          "Nem todo adeus é desamor;\nàs vezes é a forma mais honesta\nde cuidar de quem se ama.",
      },
      {
        title: "A dor do desapego é parte do crescimento",
        poem:
          "A ferida cicatriza, mas ensina;\nperdi, sofri, aprendi a respirar de novo —\ne saí maior do que entrei.",
      },
      {
        title: "Nem sempre ficar é a melhor opção",
        poem:
          "Ficar por medo também é partir de mim.\nEscolhi soltar, não por falta de amor,\nmas por respeito ao que ela merecia.",
      },
      {
        title: "O amor às vezes exige sacrifícios",
        poem:
          "Sacrifiquei o meu conforto pela sua paz;\no amor maduro não calcula perdas —\nele entrega o que for preciso.",
      },
    ],
  },
  "mulheres-chatas": {
    title: 'Qualidades das "Chatas"',
    dotColor: "bg-orange-500",
    items: [
      {
        title: "Demonstram interesse real",
        poem:
          "Ela liga, pergunta, cobra, aparece —\nnão por drama, mas porque se importa.\nE eu aprendi a ler isso como cuidado.",
      },
      {
        title: "Não têm medo de mostrar seus sentimentos",
        poem:
          "Não esconde ciúme atrás de indiferença;\ndiz o que sente, mesmo tremendo —\ne isso, para mim, é coragem.",
      },
      {
        title: "Protegem você de situações ruins",
        poem:
          "Fica de olho, alerta, na minha volta;\nnão por controle, mas por zelo —\ne eu me sinto amado quando ela cuida.",
      },
      {
        title: "Não se importam com bens materiais",
        poem:
          "Não me mede pelo carro nem pelo saldo;\nquer minha presença, minha verdade —\ne isso não tem preço.",
      },
      {
        title: "Estão sempre ao seu lado",
        poem:
          "Na queda e na vitória, ela permanece;\nnão some quando o tempo aperta —\ne quem fica assim merece tudo.",
      },
    ],
  },
  "cuida-bem-dela": {
    title: "O Valor de Quem Permanece",
    dotColor: "bg-green-500",
    items: [
      {
        title: "Nem todos permanecem nos momentos difíceis",
        poem:
          "Muitos passam, poucos ficam\nquando a noite escurece de verdade —\neu vi quem ficou e não esqueci.",
      },
      {
        title: "Quem fica merece ser valorizado",
        poem:
          "Não deixe para depois o obrigado,\no cuidado, o gesto simples —\nquem permanece precisa sentir que importa.",
      },
      {
        title: "O cuidado é uma demonstração de amor",
        poem:
          "Amar não é só dizer;\né lembrar, proteger, estar presente —\ne eu cuido porque aprendi a amar assim.",
      },
      {
        title: "Valorize enquanto tem a chance",
        poem:
          "O tempo não avisa quando cobra;\nhoje ela está aqui, nas suas mãos —\nnão espere o adeus para reconhecer.",
      },
      {
        title: "Cuide até o final",
        poem:
          "Do primeiro ao último dia,\nseja constante, seja inteiro —\no amor verdadeiro não tem data de validade.",
      },
    ],
  },
  "eu-quero-casar-com-voce": {
    title: "Sonhos de Amor",
    dotColor: "bg-pink-500",
    items: [
      {
        title: "Compartilhar a vida diária",
        poem:
          "Quero acordar ao seu lado,\npartilhar o café, o silêncio, a rotina —\ne chamar de lar o nosso comum.",
      },
      {
        title: "Construir sonhos juntos",
        poem:
          "Não quero sonhar sozinho;\nquero plantar com você o que ainda não existe —\ne ver crescer o que plantarmos.",
      },
      {
        title: "Apoiar-se mutuamente",
        poem:
          "Na queda, minha mão; na sua, a minha —\nparceiros não são só no papel,\nsão quando a vida pesa de verdade.",
      },
      {
        title: "Crescer lado a lado",
        poem:
          "Quero envelhecer aprendendo com você,\nerrar, corrigir, recomeçar —\ne ser melhor homem por sua causa.",
      },
      {
        title: "Amar pelo resto da vida",
        poem:
          "Não é promessa de um dia;\né escolha que repito cada manhã —\nte amar até o fim, de propósito.",
      },
    ],
  },
  "habitos-destruidores": {
    title: "Lições do Autocuidado",
    dotColor: "bg-red-500",
    items: [
      {
        title: "Autocuidado não é egoísmo",
        poem:
          "Cuidei de todos e me esqueci;\naprendi tarde que não posso dar\no que já não tenho dentro de mim.",
      },
      {
        title: "Precisamos cuidar de nós mesmos",
        poem:
          "Meu corpo pede pausa, minha alma pede verdade;\nninguém veio me salvar —\ntive de aprender a me sustentar.",
      },
      {
        title: "Hábitos destrutivos nos machucam por dentro",
        poem:
          "Mordo a língua, finjo que está tudo bem,\nme anulo para não incomodar —\ne por dentro, algo vai se quebrando.",
      },
      {
        title: "A solidão às vezes é necessária",
        poem:
          "Às vezes preciso ficar só\npara ouvir o que ninguém mais escuta —\ne nisso me reencontro.",
      },
      {
        title: "Mudança requer coragem",
        poem:
          "Velhos hábitos morrem devagar;\nmas cada passo que dou em direção a mim\njá é uma vitória silenciosa.",
      },
    ],
  },
  "adeus-a-inocencia": {
    title: "O Que Precisamos Defender",
    dotColor: "bg-purple-600",
    items: [
      {
        title: "A proteção das crianças deve ser prioridade",
        poem:
          "Antes de qualquer discurso, proteger;\na inocência não pede permissão —\npede quem fique entre ela e o mal.",
      },
      {
        title: "A religião não pode justificar atrocidades",
        poem:
          "Fé que silencia diante da dor\nnão é fé: é covardia com véu sagrado.\nEscrevo isso sem medo de ofender o comodismo.",
      },
      {
        title: "O silêncio é cúmplice da violência",
        poem:
          "Quem viu e calou carrega a culpa também;\no grito que não saiu virou corrente —\ne eu recuso me calar.",
      },
      {
        title: "Precisamos falar sobre abuso infantil",
        poem:
          "O assunto incomoda porque é real;\nquebrar o silêncio é o primeiro socorro —\ne eu escrevo para não virar cúmplice.",
      },
      {
        title: "A justiça deve proteger os vulneráveis",
        poem:
          "Quem não tem voz precisa de quem grite por ela;\njustiça tardia também fere —\ne eu exijo que protejam quem não pode se defender.",
      },
    ],
  },
  "amar-antes-do-tocar": {
    title: "Esse amor ensina",
    dotColor: "bg-rose-400",
    items: [
      {
        title: "Intimidade nasce da paciência e da escuta",
        poem:
          "Antes das mãos, as palavras;\nantes do toque, o silêncio que escuta —\ne eu aprendi a amar devagar.",
      },
      {
        title: "Esperar não é fraqueza — é maturidade afetiva",
        poem:
          "Não corro para o fim do poema;\nquero ler cada verso com calma —\nesperar, para mim, é respeito.",
      },
      {
        title: "O profundo vale mais que o instantâneo",
        poem:
          "O rápido passa; o fundo permanece.\nEscolhi o oceano, não só a onda —\ne o amor ganhou raiz.",
      },
      {
        title: "Distância física não apaga sintonia verdadeira",
        poem:
          "Quilômetros não apagam o que é real;\na alma encontra a alma sem mapa —\ne eu sinto você de longe.",
      },
    ],
  },
};
